import axios from './api';

export default async function checkIn() {

    return new Promise((resolve, reject) => {
         axios.post("home/dailyCheckIn", {}, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('authToken')}`,
            },
        })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
